import React from "react";
import Fade from "react-reveal/Fade";

const Process = ({items}) => {
  return (
    <section className='process'>
      <div className='process__inner'>
        <div className='process__items'>
          {items.map((item, index) => {
            return (
              <Fade bottom distance='40px'>
                <div key={index} className='process__item'>
                  <h3 className='process__title'>{item.title}</h3>
                  <div className='process__content' dangerouslySetInnerHTML={{__html: item.content}} />
                </div>
              </Fade>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default Process